;(function() {
/* @ngInject */
function FirmarenIco() {
  function normalize(value) {
    return (value || "").toString().replace(/\D/g, "").slice(0, 8);
  }

  return {
    restrict: "A",
    require: "ngModel",
    link: function (scope, element, attrs, ngModel) {
      let input = element[0];

      function normalizeInput() {
        let value = input.value;
        let normalized = normalize(value);

        if (value !== normalized) {
          let selectionStart = input.selectionStart;
          let caretPosition = selectionStart === null
            ? normalized.length
            : normalize(value.slice(0, selectionStart)).length;

          input.value = normalized;

          if (input.setSelectionRange) {
            input.setSelectionRange(caretPosition, caretPosition);
          }
        }
      }

      input.addEventListener("input", normalizeInput, true);

      ngModel.$parsers.push(normalize);
      ngModel.$formatters.push(normalize);
      ngModel.$validators.mask = function (modelValue, viewValue) {
        let value = normalize(viewValue || modelValue);
        return ngModel.$isEmpty(value) || value.length === 8;
      };

      scope.$on("$destroy", function () {
        input.removeEventListener("input", normalizeInput, true);
      });
    }
  };
}

angular.module("firmaren")
  .directive("firmarenIco", FirmarenIco);
}());
